var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "py-1 border-b border-slate-400 flex" },
    [
      !_vm.isEdit
        ? _c(
            "div",
            {
              staticClass:
                "relative h-10 px-4 flex items-center justify-between flex-grow gap-6 rounded hover:bg-slate-200 overflow-hidden",
              class: {
                "pointer-events-none": !_vm.currentUser.role.includes("admin")
              },
              on: {
                mouseenter: function($event) {
                  $event.preventDefault()
                  _vm.isHover = true
                },
                mouseleave: function($event) {
                  $event.preventDefault()
                  _vm.isHover = false
                }
              }
            },
            [
              _c("div", { staticClass: "flex max-w-152 truncate" }, [
                _c(
                  "div",
                  {
                    staticClass: "py-1 px-2 flex items-center rounded truncate",
                    style: { backgroundColor: _vm.branch.background_color }
                  },
                  [
                    _c("BlTextBody2", {
                      staticClass: "truncate",
                      style: { color: _vm.branch.color },
                      attrs: { title: _vm.branch.name, text: _vm.branch.name }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "absolute px-2 flex items-center gap-2 transition-all duration-300 bg-slate-200",
                  class: {
                    "right-2 opacity-100": _vm.isHover,
                    "-right-200 opacity-0": !_vm.isHover
                  }
                },
                [
                  _c("BlInputButton", {
                    attrs: {
                      label: "Delete",
                      type: "outlined-error",
                      dense: ""
                    },
                    on: {
                      clicked: function($event) {
                        _vm.deleteOpened = true
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: { label: "Edit", type: "outlined", dense: "" },
                    on: { clicked: _vm.openEdit }
                  })
                ],
                1
              )
            ]
          )
        : _c(
            "div",
            {
              staticClass:
                "h-10 px-4 flex items-center justify-between flex-grow gap-6 rounded bg-slate-200",
              attrs: { id: "edit-state" }
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center flex-grow gap-4" },
                [
                  _c("BlInputText", {
                    attrs: { input: _vm.nameInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "relative" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "relative h-10 w-24 px-4 flex items-center justify-between bg-pure-white border rounded cursor-pointer",
                        class: [
                          _vm.colorOpened
                            ? "border-light-purple"
                            : "border-slate-500"
                        ],
                        attrs: { "data-id": "color-branch-tag" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.colorOpened = !_vm.colorOpened
                          }
                        }
                      },
                      [
                        _c("div", {
                          staticClass:
                            "w-6 h-6 flex-shrink-0 rounded-full border border-slate-300",
                          style: {
                            backgroundColor: _vm.colorInput.backgroundColor
                          }
                        }),
                        _vm._v(" "),
                        _c("BlIcon", {
                          staticClass:
                            "absolute right-4 w-5 h-5 transition-all duration-300",
                          style: {
                            rotate: _vm.colorOpened ? "180deg" : "0deg"
                          },
                          attrs: {
                            "data-id": "color-branch-tag",
                            icon: "chevron-down"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.colorOpened
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "absolute right-0 w-54 mt-2 z-10 p-4 bg-pure-white rounded border border-grey-200 shadow-md",
                            attrs: { "data-id": "color-branch-tag" }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "grid grid-cols-6 flex-wrap gap-2",
                                attrs: { "data-id": "color-branch-tag" }
                              },
                              _vm._l(_vm.colorOptions, function(item) {
                                return _c("button", {
                                  key: item.color,
                                  staticClass:
                                    "h-6 w-6 flex-shrink-0 rounded border outline-none",
                                  class: [
                                    _vm.colorInput.color === item.color
                                      ? "border-light-purple"
                                      : "border-transparent"
                                  ],
                                  style: {
                                    backgroundColor: item.backgroundColor
                                  },
                                  attrs: { "data-id": "color-branch-tag" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.colorInput = item
                                    }
                                  }
                                })
                              }),
                              0
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex items-center flex-shrink-0 gap-2" },
                [
                  _c("BlInputButton", {
                    attrs: { label: "Cancel", type: "plain" },
                    on: {
                      clicked: function($event) {
                        _vm.isEdit = false
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    attrs: {
                      label: "Update",
                      type: "outlined",
                      dense: "",
                      loading: _vm.submitLoading,
                      disabled:
                        !_vm.nameInput.model ||
                        (_vm.nameInput.model === _vm.branch.name &&
                          _vm.colorInput.color === _vm.branch.color)
                    },
                    on: { clicked: _vm.onUpdate }
                  })
                ],
                1
              )
            ]
          ),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete tag",
                label: "Delete the tag",
                type: "error",
                disabled: _vm.submitLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onRemove
              }
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-wrap gap-1 px-8" },
                [
                  _c("BlTextBody2", {
                    attrs: { text: "You are about to delete" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "font-bold",
                    attrs: { text: _vm.branch.name }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: { text: "from the repository." }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: { text: "Are you sure you want to proceed?" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: { text: "This action is irreversible." }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5edd4a07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5edd4a07","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/tags/BranchTag.vue
// module id = null
// module chunks = 